import { render, staticRenderFns } from "./RequestViewing.vue?vue&type=template&id=6c3525b1&"
import script from "./RequestViewing.vue?vue&type=script&lang=js&"
export * from "./RequestViewing.vue?vue&type=script&lang=js&"
import style0 from "./RequestViewing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports